// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // Import authentication module
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCHLchEJSGgkB8Tod1vAmvrL9LqVp29UbI",
    authDomain: "bymolive.firebaseapp.com",
    projectId: "bymolive",
    storageBucket: "bymolive.firebasestorage.app",
    messagingSenderId: "1035841390819",
    appId: "1:1035841390819:web:95fb812630eb759a221dd6",
    measurementId: "G-RFME053FWX",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Analytics (optional)
const analytics = getAnalytics(app);

// Initialize and export Firebase Authentication
export const auth = getAuth(app);
export const db = getFirestore(app);
